import React, { FC } from 'react';
import { MapStyleKeys } from '../utils/mapStyles';
import Blade from './Blade';
import { Map, MapMarker } from './Map';

interface MapBladeProps {
  mapMarkers: MapMarker[];
  mapStyle?: MapStyleKeys;
  polygon?: google.maps.MVCArray<any> | null | any[];
  ignorePolygonFromBounds?: boolean;
  ignoreMarkersFromBounds?: boolean;
  // eslint-disable-next-line no-undef
  center?: google.maps.LatLngLiteral;
  showPolygon?: boolean;
}

export const MapBlade: FC<MapBladeProps> = ({
  mapMarkers,
  mapStyle,
  polygon,
  ignorePolygonFromBounds,
  ignoreMarkersFromBounds,
  center,
  showPolygon,
}) => (
  <Blade id="map" renderChildrenOnOpen width="wide">
    <Map
      markers={mapMarkers}
      mapStyle={mapStyle}
      polygon={polygon}
      ignorePolygonFromBounds={ignorePolygonFromBounds}
      ignoreMarkersFromBounds={ignoreMarkersFromBounds}
      center={center}
      showPolygon={showPolygon}
    />
  </Blade>
);
